import tenantsJSONfile from "config/tenants.json";
import { isBrowserEnv } from "./isWindowObjAvailable";
import type {
  TenantConfig,
  TenantsJSON,
  TroxEnvironment,
} from "interfaces/shared.types";

export const getTenantSettings = (
  tenantsJSON: TenantsJSON = tenantsJSONfile,
): TenantConfig | undefined => {
  let troxEnv: TroxEnvironment | undefined = process.env.TROX_ENVIRONMENT as
    | TroxEnvironment
    | undefined;

  if (troxEnv === "local") {
    troxEnv = "development";
  }

  if (!troxEnv) {
    console.error("TROX_ENVIRONMENT needs to be defined");
    return undefined;
  }

  const envConfig = tenantsJSON[troxEnv];

  if (!envConfig || !envConfig.tenants) {
    console.error("No tenants set for declared TROX_ENVIRONMENT");
    return undefined;
  }

  if (!envConfig.default_tenant) {
    console.error("No default_tenant set for tenants set");
    return undefined;
  }

  if (isBrowserEnv() && window.location.hostname in envConfig.tenants) {
    return envConfig.tenants[window.location.hostname];
  }

  const defaultTenant = envConfig.default_tenant;
  return envConfig.tenants[defaultTenant];
};

export const linkHostname = (
  tenantsJSON: TenantsJSON = tenantsJSONfile,
): string => `www.${tenantsJSON.production.default_tenant}`;
